import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const CarIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(1.000000, 6.000000)">
          <path
            d="M12.7472742,0 C12.1432742,0 11.4192742,0.437 11.1372742,0.97 L6.01427423,10.669 C5.73227423,11.203 5.00827423,11.64 4.40427423,11.64 L2.91127423,11.64 C2.30727423,11.64 1.58227423,12.076 1.30027423,12.61 L0.113274231,14.85 C-0.168725769,15.384 0.0942742308,15.82 0.697274231,15.82 L2.02727423,15.82 C2.63127423,15.82 2.88927423,16.255 2.60227423,16.785 L1.51627423,18.79 C1.22927423,19.321 0.993274231,20.249 0.993274231,20.852 L0.993274231,36.117 C0.993274231,36.721 1.48727423,37.215 2.09127423,37.215 L6.45427423,37.215 C7.05727423,37.215 7.55127423,36.721 7.55127423,36.117 L7.55127423,33.968 C7.55127423,33.364 8.04527423,32.87 8.64827423,32.87 L39.0782742,32.87 C39.6822742,32.87 40.1752742,33.364 40.1752742,33.968 L40.1752742,36.117 C40.1752742,36.721 40.6692742,37.215 41.2732742,37.215 L45.5542742,37.215 C46.1572742,37.215 46.6512742,36.721 46.6512742,36.117 L46.6512742,22.328 C46.6512742,21.724 46.4302742,20.789 46.1602742,20.249 L44.6012742,17.13 C44.3312742,16.59 44.6042742,16.148 45.2072742,16.148 L46.5372742,16.148 C47.1412742,16.148 47.4592742,15.687 47.2432742,15.123 L46.3052742,12.665 C46.0892742,12.101 45.4192742,11.64 44.8162742,11.64 L43.1582742,11.64 C42.5552742,11.64 41.8422742,11.197 41.5752742,10.656 L36.8082742,0.984 C36.5412742,0.443 35.8292742,0 35.2252742,0 L12.7472742,0 Z"
            fill="#ffffff"
            className={styles.white}
          ></path>
          <path
            d="M12.7472742,0 C12.1432742,0 11.4192742,0.437 11.1372742,0.97 L6.01427423,10.669 C5.73227423,11.203 5.00827423,11.64 4.40427423,11.64 L2.91127423,11.64 C2.30727423,11.64 1.58227423,12.076 1.30027423,12.61 L0.113274231,14.85 C-0.168725769,15.384 0.0942742308,15.82 0.697274231,15.82 L2.02727423,15.82 C2.63127423,15.82 2.88927423,16.255 2.60227423,16.785 L1.51627423,18.79 C1.22927423,19.321 0.993274231,20.249 0.993274231,20.852 L0.993274231,36.117 C0.993274231,36.721 1.48727423,37.215 2.09127423,37.215 L6.45427423,37.215 C7.05727423,37.215 7.55127423,36.721 7.55127423,36.117 L7.55127423,33.968 C7.55127423,33.364 8.04527423,32.87 8.64827423,32.87 L39.0782742,32.87 C39.6822742,32.87 40.1752742,33.364 40.1752742,33.968 L40.1752742,36.117 C40.1752742,36.721 40.6692742,37.215 41.2732742,37.215 L45.5542742,37.215 C46.1572742,37.215 46.6512742,36.721 46.6512742,36.117 L46.6512742,22.328 C46.6512742,21.724 46.4302742,20.789 46.1602742,20.249 L44.6012742,17.13 C44.3312742,16.59 44.6042742,16.148 45.2072742,16.148 L46.5372742,16.148 C47.1412742,16.148 47.4592742,15.687 47.2432742,15.123 L46.3052742,12.665 C46.0892742,12.101 45.4192742,11.64 44.8162742,11.64 L43.1582742,11.64 C42.5552742,11.64 41.8422742,11.197 41.5752742,10.656 L36.8082742,0.984 C36.5412742,0.443 35.8292742,0 35.2252742,0 L12.7472742,0 Z"
            stroke="#000000"
            className={styles.defaultStrokeColor}
            strokeWidth="2"
          ></path>
          <line
            stroke="#000000"
            className={styles.defaultStrokeColor}
            x1="15.2565742"
            x2="32.2245742"
            y1="21.3123"
            y2="21.3123"
          ></line>
          <line
            stroke="#000000"
            className={styles.defaultStrokeColor}
            x1="15.2565742"
            x2="32.2245742"
            y1="24.919"
            y2="24.919"
          ></line>
          <path
            d="M12.2236742,23.2796 C12.2236742,25.0456 10.7926742,26.4766 9.02667423,26.4766 C7.26167423,26.4766 5.82967423,25.0456 5.82967423,23.2796 C5.82967423,21.5136 7.26167423,20.0826 9.02667423,20.0826 C10.7926742,20.0826 12.2236742,21.5136 12.2236742,23.2796"
            fill="#0050B3"
            className={styles.interactiveColor}
          ></path>
          <path
            d="M42.2368742,23.2796 C42.2368742,25.0456 40.8058742,26.4766 39.0398742,26.4766 C37.2748742,26.4766 35.8428742,25.0456 35.8428742,23.2796 C35.8428742,21.5136 37.2748742,20.0826 39.0398742,20.0826 C40.8058742,20.0826 42.2368742,21.5136 42.2368742,23.2796"
            fill="#0050B3"
            className={styles.interactiveColor}
          ></path>
          <path
            d="M11.3287742,11.3908069 C10.7437742,11.3928 10.4607742,10.9568 10.6997742,10.4228 L13.6447742,3.8588 C13.8847742,3.3238 14.5597742,2.8868 15.1447742,2.8868 L32.7327742,2.8868 C33.3177742,2.8868 33.9977742,3.3218 34.2437742,3.8538 L37.2457742,10.3478 C37.4917742,10.8798 37.2137742,11.3158 36.6277742,11.3178 L11.3287742,11.3908069 Z"
            stroke="#000000"
            className={styles.defaultStrokeColor}
            strokeLinejoin="round"
          ></path>
        </g>
      </g>
    </Icon>
  )
}
